import TabIndicator from '../../utils/TabIndicator.jsx';
import { flushSync } from 'react-dom';
import { animateExpander } from './animateExpander';
import { useThemeContext } from '../../../contexts/Theme-Context';
import SystemSelect from './SystemSelect.jsx';
import React, { useState, useEffect, useContext, useMemo, useCallback, useRef } from "react";
import APIMiddleware from "../../../data/api/Api-Middleware";
import {
  API_ENDPOINT_CHILD_USERS,
  API_ENDPOINT_GENERATE_CHILD_LOGIN_TOKEN,
  API_ENDPOINT_SAVE_LOGIN_TOKEN,
} from "../../../data/Endpoints-API";
import { toast } from "react-toastify";
import {
  getChallengeSwitchContext,
  setChallengeSwitchContext,
  resolveParentUserDetailId,
  hasChallengeSwitchContext,
  getParentUserDetailIdForChildUsersApi,
} from "../../../utils/challengeSwitchContext";
import { getChallengePhaseLabel, isChallengeEnded } from "../../../utils/tradingLockMessage";
import {
  translatePlanName,
  translateThreeDaySwap,
  translateSymbolDescription,
  translatePhaseStatus,
  localizeChallengePhaseLabel,
} from "../../../i18n/apiDisplayLabels";
import { useSymbolContext } from "../../../contexts/Symbol-Context.js";
import { useChartContext } from "../../../contexts/Chart-Context.js";
import "./Order-Panel.scss";
import { FiGlobe, FiClock, FiChevronUp as BsArrowUpSquare, FiChevronDown as BsArrowDownSquare } from "react-icons/fi";
import { GoDotFill } from "react-icons/go";
import Select from "../../utils/Select.jsx";
import { components as selectComponents } from 'react-select';
import MarketOrder from "../market_order/Market-Order.tsx";
import NotificationsDropdown from "../notifications/NotificationDropdown.jsx"
import PendingOrder from "../pending_order/Pending-Order.tsx";
import { useAuthContext } from "../../../contexts/Auth-Context.js";
import UTCTimeConverter from "./UTCTimeConverter.jsx";
import { useMetricsContext } from '../../../contexts/Metrics-Context';
import SystemNotification from "./SystemNotification.js";
import FloatingWindow from "./FloatingWindow.jsx";
import {
  formatPrice,
  formatPriceUptoDecimals,
  formatPositionToPipSize,
  formatDigitBasePrice,
} from "../../../utils/format.js";


import { Ripple } from 'react-ripple-click';
import 'react-ripple-click/dist/index.css';

// Developed explicit Component for showing ask and bid price in the select symbol option
// import { components } from 'react-select';
// import { formatPrice } from "../../../utils/format.js";
import BotPanel from "../bot_panel/BotPanel";
import { RiRobot2Line } from "react-icons/ri";
import ReactSelect from "./React-Select.jsx";
import { useTranslation } from "react-i18next";
import { translateChartStyleName } from "../../../i18n/chartStyles";
import i18n, { setAppLocale } from "../../../i18n";
// import Switch1 from "react-switch";
import Switch from "../bot_panel/Switch.jsx"
import UpdateSection from "./UpdateSection.jsx";
import { PromotionContext } from "../../../contexts/promotionContext.js";
import DepositModal from "../../depositModal/DepositModal.jsx";
import DepositPromoModal from "../../depositModal/DepositPromoModal.jsx";
import { useAccountManagerContext } from "../../../contexts/Account-Manager-Context.js";
import BankDetails from "../../depositModal/BankDetails.jsx";
import WithdrawModal from "../../withdrawModal/WithdrawModal.jsx";
import {
  getDepositGatewayUrl,
  getDepositPromoForCurrentHost,
} from "../../../utils/depositPromoConfig.js";
import SwapCountdown from "../market_order/SwapCountdown.jsx";
import getBackendUrl from "../../utils/RedirectUrl.js";

function formatSwapRate(value) {
  if (value == null || String(value).trim() === '' || !Number.isFinite(Number(value))) return '\u2014';
  return String(value).trim();
}

// const CustomOption = ({ innerRef, innerProps, data }) => {
//   const [prevBid, setPrevBid] = useState(data.bid);
//   const [prevAsk, setPrevAsk] = useState(data.ask);
//   const [bidColor, setBidColor] = useState('#2ecc71'); // Initial color green
//   const [askColor, setAskColor] = useState('#2ecc71'); // Initial color green

//   useEffect(() => {
//     if (data.bid !== prevBid) {
//       setBidColor(data.bid > prevBid ? '#2ecc71' : '#e74c3c');
//       setPrevBid(data.bid);
//     }

//     if (data.ask !== prevAsk) {
//       setAskColor(data.ask > prevAsk ? '#2ecc71' : '#e74c3c');
//       setPrevAsk(data.ask);
//     }
//   }, [data.bid, data.ask, prevBid, prevAsk]);

//   // const formatPrice = (price) => {
//   //   if (price === undefined) return "";
//   //   const formattedPrice = price.toFixed(4);
//   //   const [whole, fractional] = formattedPrice.split('.');
//   //   const displayedFractional = fractional.length > 3 ? fractional.slice(0, 3) : fractional;
//   //   return (
//   //     <span>
//   //       {whole}.
//   //       <span className="fractional">{displayedFractional}</span>
//   //     </span>
//   //   );
//   // };

//   return (
//     <div ref={innerRef} {...innerProps} className="custom-option">
//       <div className="symbol" style={{ color: '#ffffff' }}>{data.label}</div>
//       <div className="bid" style={{ color: bidColor }}>
//         {formatPrice(data.bid)}
//       </div>
//       <div className="ask" style={{ color: askColor }}>
//         {formatPrice(data.ask)}
//       </div>
//     </div>
//   );
// };

// const CustomMenuList = (props) => {
//   return (
//     <components.MenuList {...props}>
//       <div className="header">
//         <div className="symbol-title">Symbol</div>
//         <div className="bid-title">Bid</div>
//         <div className="ask-title">Ask</div>
//       </div>
//       {props.children}
//     </components.MenuList>
//   );
// };


// Actual code of Order panel starts from here

const formatPhaseStatusLabel = (status) => {
  const raw = String(status || '').trim();
  if (!raw) return '';
  return raw.charAt(0).toUpperCase() + raw.slice(1).toLowerCase();
};

const buildChildAccountDisplay = (child) => {
  const isFunded = Number(child.is_funded) === 1 || child.is_funded === true;
  const phaseLabel = localizeChallengePhaseLabel(
    getChallengePhaseLabel({
      phase_id: child.phase_id,
      phase_index: child.phase_index,
      phase_count: child.phase_count,
      is_funded: isFunded,
    }) || i18n.t('orderPanel.phase'),
    i18n.t.bind(i18n),
  );
  const status = translatePhaseStatus(child.phase_status, i18n.t.bind(i18n));
  const planName = translatePlanName(
    String(child.plan_name || '').trim() || i18n.t('userSettings.challenge'),
    i18n.t.bind(i18n),
  );
  const accountId = child.account_id ? String(child.account_id) : '';
  const challengeRef = String(child.challenge_ref || '').trim();
  const name = child.child_user_name || child.child_email || i18n.t('orderPanel.account');
  const selectedTitle = `${planName} — ${phaseLabel}`;

  return {
    title: phaseLabel,
    selectedTitle,
    meta: accountId,
    planName,
    challengeRef,
    status,
    statusClass: String(child.phase_status || '').trim().toLowerCase(),
    phaseType: isFunded ? i18n.t('orderPanel.funded') : i18n.t('orderPanel.audition'),
    phaseTypeClass: isFunded ? 'funded' : 'audition',
    phaseIndex: Number(child.phase_index) || Number(child.phase_id) || 0,
    searchLabel: [planName, phaseLabel, status, accountId, challengeRef, name]
      .filter(Boolean)
      .join(' '),
  };
};

const flattenChallengeAccountOptions = (options = []) =>
  options.flatMap((entry) =>
    Array.isArray(entry?.options) ? entry.options : [entry]
  );

const ChallengeAccountOption = (props) => {
  const { t } = useTranslation();
  const { data } = props;
  if (data.isParent) {
    return (
      <selectComponents.Option {...props}>
        <div className="challenge-account-option is-parent">
          <div className="challenge-account-option__title">{data.label}</div>
          <div className="challenge-account-option__meta">{t('orderPanel.parentAccount')}</div>
        </div>
      </selectComponents.Option>
    );
  }

  const display = data.display || {};
  return (
    <selectComponents.Option {...props}>
      <div className="challenge-account-option">
        <div className="challenge-account-option__row">
          <div className="challenge-account-option__title">{display.title || data.label}</div>
          <div className="challenge-account-option__badges">
            {display.phaseType ? (
              <span className={`challenge-account-badge phase-type ${display.phaseTypeClass}`}>
                {display.phaseType}
              </span>
            ) : null}
            {display.status ? (
              <span className={`challenge-account-badge status ${display.statusClass}`}>
                {display.status}
              </span>
            ) : null}
          </div>
        </div>
        {display.meta ? (
          <div className="challenge-account-option__meta">{display.meta}</div>
        ) : null}
      </div>
    </selectComponents.Option>
  );
};

const ChallengeAccountSingleValue = (props) => {
  const { data } = props;
  if (data.isParent) {
    return (
      <selectComponents.SingleValue {...props}>
        <div className="challenge-account-value">{data.label}</div>
      </selectComponents.SingleValue>
    );
  }

  const display = data.display || {};
  return (
    <selectComponents.SingleValue {...props}>
      <div className="challenge-account-value">
        <span className="challenge-account-value__title">
          {display.selectedTitle || display.title || data.label}
        </span>
        {display.status ? (
          <span className={`challenge-account-badge status ${display.statusClass}`}>
            {display.status}
          </span>
        ) : null}
      </div>
    </selectComponents.SingleValue>
  );
};

const ChallengeAccountGroupHeading = (props) => {
  const data = props.data || {};
  if (data.isParentGroup) {
    return (
      <div className="challenge-account-group-heading is-parent">
        <div className="challenge-account-group-heading__name">{data.label}</div>
      </div>
    );
  }

  return (
    <div className="challenge-account-group-heading">
      <div className="challenge-account-group-heading__name">{data.planName || data.label}</div>
      {data.challengeRef ? (
        <div className="challenge-account-group-heading__id">ID: {data.challengeRef}</div>
      ) : null}
    </div>
  );
};

const challengeAccountSelectComponents = {
  Option: ChallengeAccountOption,
  SingleValue: ChallengeAccountSingleValue,
  GroupHeading: ChallengeAccountGroupHeading,
};

const OrderPanel: React.FC = () => {
  const { theme, setTheme } = useThemeContext();
  const { t, i18n } = useTranslation();
  const appearanceOptions = useMemo(() => [
    { value: 'dark', label: t('settings.darkMode') },
    { value: 'light', label: t('settings.lightMode') },
  ], [t]);
  let prePositionMarkerState = 'show';
  if (localStorage.positionMarker !== undefined) {
    prePositionMarkerState = localStorage.positionMarker;
  } else {
    localStorage.setItem('positionMarker', prePositionMarkerState);
  }
  const [positionMarker, setPositionMarker] = useState(prePositionMarkerState);
  const setPositionMarkerValue = (e) => {
    setPositionMarker(e);
    localStorage.setItem('positionMarker', e);
  }
  const fontSelecter = (e) => {
    setFont(e.target.value);
    localStorage.setItem("storedFont", e.target.value);
    fontAdjuster(e);
  };
  const [isStyleMenuOpen, setIsStyleMenuOpen] = useState(false);
  const [childUsers, setChildUsers] = useState<any[]>([]);
  const [selectedChildAccount, setSelectedChildAccount] = useState<any>(null);
  const [isChildUsersLoading, setIsChildUsersLoading] = useState(false);
  const [isChildLoginLoading, setIsChildLoginLoading] = useState(false);
  const [showChallengeSwitcher, setShowChallengeSwitcher] = useState(
    () => hasChallengeSwitchContext()
  );

  //CONTEXT
  const {
    showTooltip, setShowTooltip,
    showBullets, setShowBullets,
    symbolInfo,
    marketHours,
    symbolData: symbolListData,
    // allSymbolOptions,
    // selectedSymbolOption,
    // handleSymbolOptionChange,
    leverage,
    hideLeverageCard,
    activeLvg,
    bidPrice,
    askPrice,
    selectedSymbolSession,
    currentExposureLevel
  } = useSymbolContext();
  const { showWithdraw, setShowWithdraw, showDeposit, setShowDeposit, showBank } = useAccountManagerContext();
  const [showDepositPromo, setShowDepositPromo] = useState(false);
  const [activeDepositPromo, setActiveDepositPromo] = useState(null);
  const { isHidden } = useContext(PromotionContext);
  const { selectedStyle, setSelectedStyle, styleOptions } = useChartContext();
  const [isPositionOpening, setIsPositionOpening] = useState(false);
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  // console.log(allSymbolOptions)
  const { platFromData, selectedAuthSymbol, showFloatingWindow, setShowFloatingWindow } =
    useAuthContext();
  const { fontAdjuster, fontUpdating, user, isFirstLoginDisabled, loginWithDirectToken } = useAuthContext();
  let toggleTooltipLocal;
  if (localStorage.chartTooltips !== undefined) {
    toggleTooltipLocal = localStorage.chartTooltips;
  } else {
    localStorage.setItem('chartTooltips', 'show');
    toggleTooltipLocal = 'show';
  }
  const [toggleTooltip, setToggleTooltip] = useState(toggleTooltipLocal);
  const [font, setFont] = useState(localStorage.getItem('storedFont') || 'Large');
  const [mobileMode, setMobileMode] = useState<boolean>(false);
  const largeRef = React.useRef();

  const symbolData = platFromData[8]?.symbol ?? {};
  const bidClass = symbolData.bid_class;
  const askClass = symbolData.ask_class;

  const bidColor =
    bidClass === 'Symbol-price-up'
      ? selectedStyle.buyColor
      : bidClass === 'Symbol-price-down'
      ? selectedStyle.sellColor
      : 'var(--content-primary, #e8eaf0)'; // boldTextColor

  const askColor =
    askClass === 'Symbol-price-up'
      ? selectedStyle.buyColor
      : askClass === 'Symbol-price-down'
      ? selectedStyle.sellColor
      : 'var(--content-primary, #e8eaf0)'; // boldTextColor


  const calculateSpread = () => {
    return formatPriceUptoDecimals(Math.pow(10, symbolInfo?.pip_position) * (formatPriceUptoDecimals(askPrice, symbolInfo.digit) - formatPriceUptoDecimals(bidPrice, symbolInfo.digit)), 2)
  }

  // bot is subscribed or not
  const subscribed = platFromData[7]['show_bot_stats'] != undefined && platFromData[7]['show_bot_stats'] == 1 ? true : false;

  const resetChanges = () => {
    const c: boolean = window.confirm(
      i18n.t('orderPanel.confirmResetBrowser')
    );
    if (c) {
      const makeSure = () => {
        for (let i = 0; i < localStorage.length; i++) {
          if (
            localStorage.key(i) !== "userId" &&
            localStorage.key(i) !== "userData" &&
            localStorage.key(i) !== "variantId"
          ) {
            localStorage.removeItem(localStorage.key(i));
            if (localStorage.length !== 1) {
              makeSure();
              window.location.reload();
            }
          }
        }
      };
      makeSure();
    }
  };

  const handleTooltipToggle = (checked: boolean) => {
    setShowTooltip(checked);
  };
  const handleDisabledButton = (data) => {
    setIsButtonDisabled(data)
  };

  //LOcal States
  const [activeMode, setActiveMode] = useState("order");
  const [selectedTab, setSelectedTab] = useState("market");
  const orderTabsRef = useRef<HTMLDivElement>(null);
  // Underline motion comes from shared <TabIndicator /> (FLIP scaleX + translate).
  useEffect(() => {
    if (localStorage.getItem("activeMode") != null) {
      setActiveMode(["order", "settings"].includes(localStorage.getItem("activeMode")) ? localStorage.getItem("activeMode") : "order");
    }
    if (localStorage.getItem("orderTab") != null) {
      setSelectedTab(localStorage.getItem("orderTab"));
    }
  }, [localStorage.getItem("activeMode"), localStorage.getItem("orderTab"), localStorage.getItem("direction")]);

  const getMinimumLeverage = (userLeverage, groupLeverage, symbolLeverage) => {

    const parsedUserLeverage = parseFloat(userLeverage);
    const parsedGroupLeverage = parseFloat(groupLeverage);
    const parsedSymbolLeverage = parseFloat(symbolLeverage);
    // If groupLeverage is defined and not NaN
    if (groupLeverage !== undefined && groupLeverage !== null && groupLeverage !== 'null' && !isNaN(parsedGroupLeverage)) {
      return Math.min(parsedUserLeverage, parsedGroupLeverage);
    }

    // If symbolLeverage is defined and not NaN
    if (symbolLeverage !== undefined && symbolLeverage !== null && symbolLeverage !== 'null' && !isNaN(parsedSymbolLeverage)) {
      return Math.min(parsedUserLeverage, parsedSymbolLeverage);
    }

    // Default to userLeverage or 1 if userLeverage is NaN
    return isNaN(parsedUserLeverage) ? 1 : parsedUserLeverage;
  };
  const {
    currentUTCDate,
    utcOffset,
    setUTCOffset,
    formatTime,
    utcOffsetInitial,
  } = useMetricsContext();


  const handleChangeUTCOffset = (selectedOption) => {
    localStorage.setItem('utc_time', selectedOption.value);
    if (selectedOption) {
      setUTCOffset(selectedOption.value);
    }
  };


  const localeOptions = useMemo(
    () => [
      { value: 'en', label: t('common.english') },
      { value: 'it', label: t('common.italian') },
    ],
    [t, i18n.language],
  );
  const activeLocale = i18n.language?.startsWith('it') ? 'it' : 'en';

  const handleChangeLocale = (selectedOption) => {
    if (selectedOption?.value) {
      setAppLocale(selectedOption.value);
    }
  };

  const formatParentAccountLabel = (parentContext = getChallengeSwitchContext()) => {
    const name = parentContext?.parentUserName || user?.userName || t('orderPanel.parentAccountName');
    const accountId = parentContext?.parentUserAccountId || user?.userAccountId;
    const accountSuffix = accountId ? ` - ${accountId}` : '';
    return `${name}${accountSuffix}`;
  };

  const fetchChildUsers = useCallback(async () => {
    if (!user?.userId) {
      setChildUsers([]);
      return [];
    }

    const parentUserDetailId = getParentUserDetailIdForChildUsersApi(user.userId);
    if (!parentUserDetailId) {
      setChildUsers([]);
      return [];
    }

    try {
      setIsChildUsersLoading(true);
      const response = await APIMiddleware.get(API_ENDPOINT_CHILD_USERS(parentUserDetailId));
      const rows = Array.isArray(response?.data) ? response.data : [];
      setChildUsers(rows);

      const isLoggedInUserAChild = rows.some(
        (child) => Number(child.user_detail_id) === Number(user.userId)
      );

      if (rows.length === 0 || (isLoggedInUserAChild && !hasChallengeSwitchContext())) {
        setShowChallengeSwitcher(false);
      } else {
        setShowChallengeSwitcher(true);
        if (!hasChallengeSwitchContext() && !isLoggedInUserAChild) {
          setChallengeSwitchContext({
            parentUserDetailId,
            parentUserName: user.userName,
            parentUserAccountId: user.userAccountId,
          });
        }
      }

      return rows;
    } catch (error) {
      console.error('Error fetching child users:', error);
      setChildUsers([]);
      return [];
    } finally {
      setIsChildUsersLoading(false);
    }
  }, [user?.userId, user?.userName, user?.userAccountId]);

  const isViewOnlyMode =
    localStorage.getItem('accountType') === '0' ||
    platFromData?.[5]?.accessRight == 3 ||
    platFromData?.[5]?.accountType == 0 ||
    platFromData?.[5]?.account_type == 0 ||
    user?.accountType === 0 ||
    user?.accountType === '0' ||
    user?.role === 0 ||
    user?.role === '0' ||
    user?.accessRight == 3 ||
    isChallengeEnded(platFromData?.[5]);

  const canShowChallengeSwitcher = showChallengeSwitcher && !isViewOnlyMode;

  useEffect(() => {
    if (canShowChallengeSwitcher) {
      fetchChildUsers();
    }
  }, [fetchChildUsers, canShowChallengeSwitcher]);

  const handleChildAccountMenuOpen = () => {
    window.requestAnimationFrame(() => {
      if (canShowChallengeSwitcher) {
        fetchChildUsers();
      }
    });
  };

  const childAccountOptions = useMemo(() => {
    if (!user?.userId || !canShowChallengeSwitcher) {
      return [];
    }

    const parentContext = getChallengeSwitchContext();
    const parentUserDetailId = resolveParentUserDetailId(user.userId);

    const parentGroup = {
      label: t('orderPanel.mainAccount'),
      isParentGroup: true,
      options: [
        {
          value: parentUserDetailId,
          label: formatParentAccountLabel(parentContext),
          isParent: true,
        },
      ],
    };

    const groupsByChallenge = new Map();

    childUsers.forEach((child) => {
      const display = buildChildAccountDisplay(child);
      const challengeKey = String(
        child.challenge_id || child.challenge_ref || child.user_detail_id
      );
      if (!groupsByChallenge.has(challengeKey)) {
        groupsByChallenge.set(challengeKey, {
          label: display.planName,
          planName: display.planName,
          challengeRef: display.challengeRef,
          challengeId: child.challenge_id,
          sortAt: child.phase_started_at || '',
          options: [],
        });
      }

      const group = groupsByChallenge.get(challengeKey);
      if (child.phase_started_at && String(child.phase_started_at) > String(group.sortAt || '')) {
        group.sortAt = child.phase_started_at;
      }

      group.options.push({
        value: child.user_detail_id,
        label: display.searchLabel,
        isParent: false,
        child,
        display,
      });
    });

    const challengeGroups = Array.from(groupsByChallenge.values())
      .map((group) => ({
        ...group,
        options: [...group.options].sort(
          (a, b) => (a.display?.phaseIndex || 0) - (b.display?.phaseIndex || 0)
        ),
      }))
      .sort((a, b) => String(b.sortAt || '').localeCompare(String(a.sortAt || '')));

    return [parentGroup, ...challengeGroups];
  }, [childUsers, user?.userId, user?.userName, user?.userAccountId, canShowChallengeSwitcher, t, i18n.language]);

  const flatChildAccountOptions = useMemo(
    () => flattenChallengeAccountOptions(childAccountOptions),
    [childAccountOptions]
  );

  useEffect(() => {
    if (!user?.userId || flatChildAccountOptions.length === 0) {
      return;
    }

    const currentOption =
      flatChildAccountOptions.find(
        (option) => Number(option.value) === Number(user.userId)
      ) || flatChildAccountOptions[0];

    setSelectedChildAccount(currentOption);
  }, [user?.userId, flatChildAccountOptions]);

  const handleChangeChildAccount = async (selectedOption) => {
    if (!selectedOption) {
      setSelectedChildAccount(null);
      return;
    }

    if (Number(selectedOption.value) === Number(user?.userId)) {
      setSelectedChildAccount(selectedOption);
      return;
    }

    const parentOption = flatChildAccountOptions.find((option) => option.isParent);
    if (!parentOption) {
      return;
    }

    const parentUserDetailId = Number(parentOption.value);
    const existingContext = getChallengeSwitchContext();
    const isCurrentlyParent = Number(user.userId) === parentUserDetailId;

    setChallengeSwitchContext({
      parentUserDetailId,
      parentUserName: isCurrentlyParent
        ? user.userName
        : existingContext?.parentUserName || '',
      parentUserAccountId: isCurrentlyParent
        ? user.userAccountId
        : existingContext?.parentUserAccountId || '',
    });

    const previousSelection =
      flatChildAccountOptions.find(
        (option) => Number(option.value) === Number(user?.userId)
      ) || null;

    setSelectedChildAccount(selectedOption);

    try {
      setIsChildLoginLoading(true);
      const tokenResponse = await APIMiddleware.get(
        API_ENDPOINT_GENERATE_CHILD_LOGIN_TOKEN(parentUserDetailId, selectedOption.value)
      );
      const token = tokenResponse?.data?.[0]?.directLoginToken;

      if (!token) {
      toast.error(t('toasts.accountSwitchFailed'), {
          position: "top-right",
        });
        setSelectedChildAccount(previousSelection);
        return;
      }

      const loggedIn = await loginWithDirectToken(token);
      if (!loggedIn) {
        toast.error(t('toasts.accountLoginFailed'), {
          position: "top-right",
        });
        setSelectedChildAccount(previousSelection);
      }
    } catch (error) {
      console.error("Error switching challenge account:", error);
      toast.error(t('toasts.accountSwitchFailed'), {
        position: "top-right",
      });
      setSelectedChildAccount(previousSelection);
    } finally {
      setIsChildLoginLoading(false);
    }
  };
  const getExposureLevel = (number, array) => {
    if (!array || array.length === 0) {
      return null;
    }

    if (array[0]?.exposure_level === undefined || array[array.length - 1]?.exposure_level === undefined) {
      return null;
    }

    if (number < array[0]?.exposure_level) {
      return array[0];
    }

    if (number > array[array.length - 1]?.exposure_level) {
      return array[array.length - 1];
    }
    for (let i = 0; i < array.length; i++) {
      if (array[i]?.exposure_level !== undefined && number <= array[i]?.exposure_level) {
        return array[i];
      }
    }

    // Return null or some default value if no match is found
    return null;
  };

  const marketTypeOptions = useMemo(
    () => [
      { label: t('orderPanel.marketOrder'), value: 'market' },
      { label: t('orderPanel.pendingOrder'), value: 'pending-order' },
      { label: t('orderPanel.botTrading'), value: 'bot-trading' },
    ],
    [t],
  );

  const customStyles = {
    option: (provided, state) => ({
      ...provided,
      padding: '7px !important',
      color: 'var(--content-primary, #e8eaf0)', // Updated to match theme $boldTextColor
      borderColor: 'var(--surface-border, #3a4156) !important', // Updated to match theme $inputBorderColor
      // backgroundColor: state.isFocused ? 'rgb(0, 217, 126) !important' : null,
      backgroundColor: null,
      '&:hover': {
        backgroundColor: 'rgb(0, 217, 126) !important', // Updated to match theme $greenButton
        cursor: 'pointer',
      },
      cursor: 'pointer',
    }),
    control: (provided, state) => ({
      ...provided,
      width: '100%',
      backgroundColor: 'var(--surface-bg, #1a1f36) !important', // Updated to match theme $bodyColor
      borderColor: 'var(--surface-border, #3a4156) !important', // Updated to match theme $inputBorderColor
      boxShadow: state.isFocused ? 'var(--surface-border, #3a4156) !important' : provided.boxShadow,
    }),
    menu: (provided) => ({
      ...provided,
      backgroundColor: 'var(--surface-raised, #2f3549) !important', // Updated to match theme $firstBoxButton
      width: '100% !important',
      zIndex: 111,
    }),
    menuList: (provided) => ({
      ...provided,
      maxHeight: '120px !important',
      overflowY: 'auto',
    }),
    input: (provided) => ({
      ...provided,
      padding: '0 !important'
    }),
  };

  const options = useMemo(() => [
    { value: '-12:00', label: 'UTC-12:00' },
    { value: '-11:30', label: 'UTC-11:30' },
    { value: '-11:00', label: 'UTC-11:00' },
    { value: '-10:30', label: 'UTC-10:30' },
    { value: '-10:00', label: 'UTC-10:00' },
    { value: '-09:30', label: 'UTC-9:30' },
    { value: '-09:00', label: 'UTC-9:00' },
    { value: '-08:30', label: 'UTC-8:30' },
    { value: '-08:00', label: 'UTC-8:00' },
    { value: '-07:30', label: 'UTC-7:30' },
    { value: '-07:00', label: 'UTC-7:00' },
    { value: '-06:30', label: 'UTC-6:30' },
    { value: '-06:00', label: 'UTC-6:00' },
    { value: '-05:45', label: 'UTC-5:45' },
    { value: '-05:30', label: 'UTC-5:30' },
    { value: '-05:00', label: 'UTC-5:00' },
    { value: '-04:30', label: 'UTC-4:30' },
    { value: '-04:00', label: 'UTC-4:00' },
    { value: '-03:30', label: 'UTC-3:30' },
    { value: '-03:00', label: 'UTC-3:00' },
    { value: '-02:30', label: 'UTC-2:30' },
    { value: '-02:00', label: 'UTC-2:00' },
    { value: '-01:30', label: 'UTC-1:30' },
    { value: '-01:00', label: 'UTC-1:00' },
    { value: '+00:00', label: 'UTC+0' },
    { value: '+01:00', label: 'UTC+1:00' },
    { value: '+02:00', label: 'UTC+2:00' },
    { value: '+02:30', label: 'UTC+2:30' },
    { value: '+03:00', label: 'UTC+3:00' },
    { value: '+03:30', label: 'UTC+3:30' },
    { value: '+04:00', label: 'UTC+4:00' },
    { value: '+04:30', label: 'UTC+4:30' },
    { value: '+05:00', label: 'UTC+5:00' },
    { value: '+05:30', label: 'UTC+5:30' },
    { value: '+05:45', label: 'UTC+5:45' },
    { value: '+06:00', label: 'UTC+6:00' },
    { value: '+06:30', label: 'UTC+6:30' },
    { value: '+07:00', label: 'UTC+7:00' },
    { value: '+07:30', label: 'UTC+7:30' },
    { value: '+08:00', label: 'UTC+8:00' },
    { value: '+08:45', label: 'UTC+8:45' },
    { value: '+09:00', label: 'UTC+9:00' },
    { value: '+09:30', label: 'UTC+9:30' },
    { value: '+10:00', label: 'UTC+10:00' },
    { value: '+10:30', label: 'UTC+10:30' },
    { value: '+11:00', label: 'UTC+11:00' },
    { value: '+11:30', label: 'UTC+11:30' },
    { value: '+12:00', label: 'UTC+12:00' },
    { value: '+13:00', label: 'UTC+13:00' },
    { value: '+14:00', label: 'UTC+14:00' },
  ], []);
  const orderCustomStyles = {
    control: (provided, state) => ({
      ...provided,
      minHeight: '15px !important',
      width: '100%',
      borderColor: 'var(--surface-border, #3a4156) !important', // Updated to match theme $inputBorderColor
      backgroundColor: 'var(--surface-bg, #1a1f36) !important', // Updated to match theme $bodyColor
      boxShadow: state.isFocused
        ? '0 0 50px var(--surface-border, #3a4156) !important' // Updated to match theme $inputBorderColor
        : provided.boxShadow,
      cursor: 'pointer',
      '&:hover': {
        borderColor: `${selectedStyle.buyColor} !important`,
        cursor: 'pointer',
        boxShadow: '0 0 0 transparent !important',
      },
    }),

    singleValue: (provided, state) => ({
      ...provided,
      paddingLeft: '10px !important',
      borderColor: state.isFocused
        ? `${selectedStyle.buyColor} !important`
        : 'var(--surface-border, #3a4156) !important', // Updated to match theme $inputBorderColor
      color: 'var(--content-secondary, #b8bcc8) !important', // Updated to match theme $normalTextColor
    }),
    indicatorSeparator: (provided, state) => ({
      ...provided,
      backgroundColor: 'var(--surface-border, #3a4156) !important', // Updated to match theme $inputBorderColor
      borderColor: state.isFocused
        ? `${selectedStyle.buyColor} !important`
        : 'var(--surface-border, #3a4156) !important', // Updated to match theme $inputBorderColor
      color: 'var(--surface-border, #3a4156) !important', // Updated to match theme $inputBorderColor
    }),

    option: (provided, state, inSettings = true) => {
      const selectedLook = {
        backgroundColor: 'var(--dropdown-selected-bg) !important',
        color: 'var(--buy-color) !important',
      };
      const hoverLook = {
        backgroundColor: 'var(--buy-color) !important',
        color: 'var(--dropdown-hover-fg, #1a1f36) !important',
      };
      return {
        ...provided,
        padding: inSettings ? '0.3rem !important' : '0 !important',
        cursor: 'pointer',
        borderBottom: 'none',
        ...(state.isSelected
          ? selectedLook
          : state.isFocused
            ? hoverLook
            : {
                color: 'var(--content-secondary, #b8bcc8) !important',
                backgroundColor: 'transparent',
              }),
        '&:hover': state.isSelected ? selectedLook : hoverLook,
        '&:nth-last-child(1)': {
          borderBottom: 'none !important',
        },
      };
    },

    menu: (provided) => ({
      ...provided,
      backgroundColor: 'var(--surface-raised, #2f3549) !important', // Updated to match theme $firstBoxButton
      width: 'calc(100% - 1.6rem) !important',
      margin: '0.3rem 0.8rem 0 0.8rem !important',
      zIndex: 111,
    }),

    menuList: (provided) => ({
      ...provided,
      maxHeight: '130px',
      overflowY: 'auto',
    }),
  };

  const challengeAccountSelectStyles = {
    ...orderCustomStyles,
    control: (provided, state) => ({
      ...orderCustomStyles.control(provided, state),
      minHeight: '32px',
      height: '32px',
      width: '100%',
      maxWidth: '100%',
      border: 'none',
      borderRadius: '4px',
      background: 'transparent',
      boxShadow: 'none',
      cursor: 'pointer',
      '&:hover': {
        border: 'none',
        background: 'transparent',
      },
    }),
    singleValue: (provided, state) => ({
      ...orderCustomStyles.singleValue(provided, state),
      paddingLeft: '0',
      maxWidth: '100%',
      overflow: 'hidden',
      fontSize: '12px',
      fontWeight: 600,
    }),
    valueContainer: (provided) => ({
      ...provided,
      padding: '0 10px',
      height: '30px',
      overflow: 'hidden',
    }),
    indicatorsContainer: (provided) => ({
      ...provided,
      height: '30px',
    }),
    dropdownIndicator: (provided) => ({
      ...provided,
      padding: '0 8px 0 4px',
    }),
    option: (provided, state) => {
      const selectedLook = {
        backgroundColor: 'var(--dropdown-selected-bg) !important',
        color: 'var(--buy-color) !important',
      };
      const hoverLook = {
        backgroundColor: 'var(--buy-color) !important',
        color: 'var(--dropdown-hover-fg, #1a1f36) !important',
      };
      return {
        ...orderCustomStyles.option(provided, state),
        padding: '8px 12px !important',
        margin: '0 !important',
        width: '100%',
        boxSizing: 'border-box',
        borderRadius: 0,
        borderBottom: 'none',
        ...(state.isSelected
          ? selectedLook
          : state.isFocused
            ? hoverLook
            : {
                backgroundColor: 'transparent',
                color: 'var(--content-secondary, #b8bcc8) !important',
              }),
        '&:hover': state.isSelected ? selectedLook : hoverLook,
        '&:nth-last-child(1)': {
          borderBottom: 'none !important',
        },
      };
    },
    menu: (provided) => ({
      ...orderCustomStyles.menu(provided),
      width: '100%',
      minWidth: '100%',
      maxWidth: '100%',
      margin: '6px 0 0 0',
      left: 0,
      right: 0,
      boxSizing: 'border-box',
      padding: '8px',
      border: '1px solid var(--ea-border, var(--surface-border, #3a4156))',
      borderRadius: '7px',
      boxShadow: '0 8px 24px rgba(0, 0, 0, 0.25)',
      background: 'var(--ea-raised, var(--surface-raised, #2f3549))',
      overflow: 'hidden',
      zIndex: 40,
    }),
    menuList: (provided) => ({
      ...provided,
      maxHeight: '360px',
      overflowY: 'auto',
      padding: '0 !important',
      boxSizing: 'border-box',
    }),
    group: (provided) => ({
      ...provided,
      paddingTop: 0,
      paddingBottom: 4,
      paddingLeft: 0,
      paddingRight: 0,
      marginBottom: 0,
    }),
    groupHeading: () => ({
      margin: 0,
      padding: 0,
    }),
  };


  useEffect(() => {
    // TODO: use an alternative to useRef
    if (largeRef.current && localStorage.getItem('storedFont') == null) {
      const tempObj = { target: { value: 'Large' } };
      // setFont('Large');
      localStorage.setItem("storedFont", 'Large');
      fontAdjuster(tempObj);
    }
  }, [largeRef.current]);


  useEffect(() => {
    const checkMobileMode = () => {
      const isMobile = window.innerWidth <= 960;
      setMobileMode(isMobile);
    };

    // Initial check
    checkMobileMode();

    // Add event listener for window resize
    window.addEventListener('resize', checkMobileMode);

    // Clean up event listener on unmount
    return () => {
      window.removeEventListener('resize', checkMobileMode);
    };
  }, []);

  const [collapseState, setCollapseState] = useState({
    orders: true,
    symbols: false,
    market_hours: false,
    leverage: false,
    promotion: true,
  });

  // Determine classes based on activeMode
  const orderPanelClass = (activeMode === "order" || activeMode === "withdraw" || activeMode === "deposit") ? "visible" : "hidden";
  const settingsClass = activeMode === "settings" ? "visible" : "hidden";
  const updatePanelClass = activeMode === "update" ? "visible" : "hidden";
  const notificationClass = activeMode === "notifications" ? "visible" : "hidden";

  const handleModeClick = (mode: string) => {
    setActiveMode(mode);
    localStorage.setItem("activeMode", mode);
  };

  const handleDepositTabClick = () => {
    setShowDeposit(false);
    const promo = getDepositPromoForCurrentHost();
    if (promo) {
      setActiveDepositPromo(promo);
      setShowDepositPromo(true);
      return;
    }
    window.open(getDepositGatewayUrl(), '_blank');
  };

  const handleDepositPromoProceed = () => {
    const url = activeDepositPromo?.gatewayUrl || getDepositGatewayUrl();
    window.open(url, '_blank', 'noopener,noreferrer');
    setShowDepositPromo(false);
    setActiveDepositPromo(null);
  };

  const loginToWithdrawPortal = async () => {
    try {
      if (user && user.userId != undefined && user.userId > 0) {
        const response = await APIMiddleware.get(
          API_ENDPOINT_SAVE_LOGIN_TOKEN(user.userId)
        );
        if (response.data[0].UserLoginToken) {
          window.open(
            `${getBackendUrl()}/auto_login?token=${response.data[0].UserLoginToken}&redirect=withdraw_request`,
            '_blank'
          );
        }
      }
    } catch (error) {
      toast.error(t('toasts.genericError'), {
        position: "top-right",
      });
      console.error(`Error getting user`, error);
    }
  };

  const handleTabClick = (tab: string) => {
    setSelectedTab(tab);
    localStorage.setItem("orderTab", tab);
  };

  useEffect(() => {
    if (!subscribed) {
      handleTabClick('market');
    }
  }, [subscribed]);

  // Chart shows the only platform loader while symbols load.
  // Keep the order panel mounted without its own spinner.

  const expanderAnimation = useRef<null | (() => void)>(null);
  useEffect(() => () => expanderAnimation.current?.(), []);
  const handleCollapseClick = (section, event) => {
    expanderAnimation.current?.();
    const header = event.currentTarget;
    expanderAnimation.current = animateExpander(header, () => {
      flushSync(() => setCollapseState((prevState) => ({
        ...prevState,
        [section]: !prevState[section],
      })));
    }, () => {
      const body = header.nextElementSibling;
      if (!header.isConnected || !body) return;
      let panel = header.parentElement;
      while (panel && !/(auto|scroll)/.test(getComputedStyle(panel).overflowY)) panel = panel.parentElement;
      if (!panel) return;
      const viewport = panel.getBoundingClientRect();
      const start = header.getBoundingClientRect().top;
      const end = body.getBoundingClientRect().bottom;
      const available = panel.clientHeight - 16;
      const delta = end - start > available ? start - viewport.top - 8
        : end > viewport.top + panel.clientHeight - 8 ? end - viewport.top - panel.clientHeight + 8
        : start < viewport.top + 8 ? start - viewport.top - 8 : 0;
      if (Math.abs(delta) > 1) panel.scrollBy({ top: delta, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    });
  };
  const orderStyles = {
    container: (provided) => ({
      ...provided,
      display: 'flex',
      justifyContent: 'center',
    }),
    control: (provided, state) => {
      return {
        ...provided,
        paddingLeft: '10px !important',
        boxShadow: state.isFocused ? '0 0 50px var(--surface-border, #3a4156) !important' : provided.boxShadow,
        '&:hover': {
          borderColor: 'rgb(0, 217, 126) !important', // Updated to match theme $greenButton
          cursor: 'pointer',
          boxShadow: '0 0 0 transparent !important',
        },
        backgroundColor: 'var(--surface-bg, #1a1f36) !important', // Updated to match theme $bodyColor
        borderColor: 'var(--surface-border, #3a4156) !important', // Updated to match theme $inputBorderColor
        width: 'calc(100% - 0.9rem) !important',
        cursor: 'pointer',
        margin: '0 auto !important',
      };
    },
    singleValue: (provided, state) => ({
      ...provided,
      paddingLeft: '10px !important',
      borderColor: state.isFocused ? 'rgb(0, 217, 126) !important' : 'var(--surface-border, #3a4156) !important', // Updated to match theme
      color: 'var(--content-secondary, #b8bcc8) !important', // Updated to match theme $normalTextColor
    }),
    indicatorSeparator: (provided, state) => ({
      ...provided,
      backgroundColor: 'var(--surface-border, #3a4156) !important', // Updated to match theme $inputBorderColor
      borderColor: state.isFocused ? 'rgb(0, 217, 126) !important' : 'var(--surface-border, #3a4156) !important', // Updated to match theme
      color: 'var(--surface-border, #3a4156) !important', // Updated to match theme $inputBorderColor
    }),
    option: (provided, state) => {
      const selectedLook = {
        backgroundColor: 'var(--dropdown-selected-bg) !important',
        color: 'var(--buy-color) !important',
      };
      const hoverLook = {
        backgroundColor: 'var(--buy-color) !important',
        color: 'var(--dropdown-hover-fg, #1a1f36) !important',
      };
      return {
        ...provided,
        padding: '0.3rem !important',
        cursor: 'pointer',
        borderBottom: 'none',
        '&:nth-last-child(1)': {
          borderBottom: 'none !important',
        },
        ...(state.isSelected
          ? selectedLook
          : state.isFocused
            ? hoverLook
            : {
                backgroundColor: 'transparent',
                color: 'var(--content-secondary, #b8bcc8) !important',
              }),
        '&:hover': state.isSelected ? selectedLook : hoverLook,
      };
    },
    menu: (provided) => ({
      ...provided,
      backgroundColor: 'var(--surface-raised, #2f3549) !important', // firstBoxButton
      zIndex: 111,
      width: 'calc(100% - 2.25rem) !important',
      margin: '0 auto !important',
    }),
    menuList: (provided) => ({
      ...provided,
      maxHeight: '50vh',
      overflowY: 'auto',
      padding: '20px !important'
    }),
  };
  return (
    <div className="global-platfrom">
      {
        showDeposit && <DepositModal />
      }
      {
        showBank && <BankDetails />
      }
      {
        showWithdraw && <WithdrawModal />
      }
      <DepositPromoModal
        open={showDepositPromo}
        config={activeDepositPromo}
        onClose={() => {
          setShowDepositPromo(false);
          setActiveDepositPromo(null);
        }}
        onProceed={handleDepositPromoProceed}
      />
      <div className="global-platform-order-child">
        <div className="mode-tabs" >
          <TabIndicator activeKey={activeMode} />
          <button
            className={`mode-tab-button ${activeMode === "deposit" ? "mode-tab-active" : ""
              }`}
            onClick={handleDepositTabClick}
            style={{
              position: 'relative',
              overflow: 'hidden',
              isolation: 'isolate',
            }}
            disabled={isFirstLoginDisabled || (platFromData[5]?.riskLocked || platFromData[5]?.accessRight == 3) || localStorage.getItem('accountType') == "0" || platFromData[5]?.accessRight == 2 || isButtonDisabled}
          >
            
            {t('orderPanel.deposit')}
          </button>
          <button
            className={`mode-tab-button ${activeMode === "withdraw" ? "mode-tab-active" : ""}`}
            onClick={() => {

              setShowWithdraw(true);
            }}
            style={{
              position: 'relative',
              overflow: 'hidden',
              isolation: 'isolate',
            }}
            disabled={isFirstLoginDisabled || (platFromData[5]?.riskLocked || platFromData[5]?.accessRight == 3) || localStorage.getItem('accountType') == "0" || platFromData[5]?.accessRight == 2 || isButtonDisabled}
          >
            
            {t('orderPanel.withdraw')}
          </button>
          <button data-active={activeMode === "order"}
            className={`mode-tab-button ${activeMode === "order" ? "mode-tab-active" : ""
              }`}
            onClick={() => {
              handleModeClick("order");
            }}
            style={{
              position: 'relative',
              overflow: 'hidden',
              isolation: 'isolate',
            }}
          >
            
            {t('orderPanel.order')}
          </button>
          <button data-active={activeMode === "settings"}
            className={`mode-tab-button ${activeMode === "settings" ? "mode-tab-active" : ""
              }`}
            onClick={() => {
              handleModeClick("settings");
            }}
            style={{
              position: 'relative',
              overflow: 'hidden',
              isolation: 'isolate',
            }}
          >
            
            {t('common.settings')}
          </button>
          {/* { isHidden &&
          <button
            className={`mode-tab-button ${activeMode === "update" ? "mode-tab-active" : ""
              }`}
            onClick={() => {
              handleModeClick("update");
            }}
            style={{
              position: 'relative',
              // left:'48%',
              overflow: 'hidden',
              isolation: 'isolate',

            }}
          >
            <Ripple />
            Promotions
          </button>
          } */}
          {/* <button
              className={`mode-tab-button ${activeMode === "notifications" ? "mode-tab-active" : ""
              }`}
            onClick={() => {
              handleModeClick("notifications");
            }}
            style={{
              position: 'relative',
              overflow: 'hidden',
              isolation: 'isolate',
            }}
          >
            <Ripple />
            Notifications
          </button> */}

          {!mobileMode && (
            <div className="mode-tabs-notify" aria-hidden={false}>
              <NotificationsDropdown />
            </div>
          )}
        </div>
        <div className={`order-panel ${orderPanelClass}`}>
          <div className="symbol-selector-container">
            <ReactSelect />
            {/* <Select className="testclass100"
              value={selectedSymbolOption}
              onChange={handleSymbolOptionChange}
              options={allSymbolOptions}
              isSearchable
              placeholder={t('settings.selectSymbol')}
              components={{ Option: CustomOption, MenuList: CustomMenuList }}
            /> */}
          </div>
          <div className="order-ticket-title">{t('orderPanel.newOrder')}</div>
          <div className="collapse-card-container order-ticket" role="visible">
            <div className="collapse-card-wrapper">
              <div className="flex-container">
                {mobileMode ? (
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      fontSize: '11px',
                      justifyContent: 'space-between',
                      width: '100%',
                      gap: '10px',
                    }}
                  >
                    <span
                      style={{
                        flex: '0 1 auto',
                        textAlign: 'start',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        maxWidth: '120px',
                      }}
                      title={symbolListData[selectedAuthSymbol]?.description || selectedAuthSymbol}
                    >
                      {selectedAuthSymbol}
                    </span>
                    <span style={{ flex: '1', textAlign: 'center' }}>
                      Bid: <span style={{ color: bidColor }}>{bidPrice}</span>
                    </span>
                    <span style={{ flex: '1', textAlign: 'center' }}>
                      Ask: <span style={{ color: askColor }}>{askPrice}</span>
                    </span>
                    <span
                      style={{
                        flex: '0 1 auto',
                        textAlign: 'end',
                        whiteSpace: 'nowrap',
                      }}
                    >
                      {`${t('orderPanel.spread')}: ${calculateSpread() ?? '--'}`}
                    </span>
                  </div>
                ) : (
                  null
                )}

                {platFromData[1]?.dailyChange && (
                  <div
                    className={
                      parseFloat(platFromData[1].dailyChange.split('(')[0]) >= 0
                        ? 'positive'
                        : 'negative'
                    }
                  >
                    {platFromData[1]?.dailyChange}
                  </div>
                )}
              </div>

            {
               false && symbolInfo?.swap_period &&
              <div className="flex-container">
                <div>{t('orderPanel.swapCountdown')}</div>
                <SwapCountdown />
              </div>
              }



              {
                !mobileMode &&
                // <div className="order-tabs">
                //   <button
                //     className={`tab-button ${selectedTab === "market" ? "order-tab-active" : ""
                //       }`}
                //     onClick={() => {
                //       handleTabClick("market");
                //     }}
                //     style={{
                //       position: 'relative',
                //       overflow: 'hidden',
                //       isolation: 'isolate',
                //     }}
                //   >
                //     <Ripple />
                //     Market
                //   </button>
                //   <button
                //     className={`tab-button ${selectedTab === "pending-order" ? "order-tab-active" : ""
                //       }`}
                //     onClick={() => {
                //       handleTabClick("pending-order");
                //     }}
                //     style={{
                //       position: 'relative',
                //       overflow: 'hidden',
                //       isolation: 'isolate',
                //     }}
                //   >
                //     <Ripple />
                //     Pending Order
                //   </button>
                //   {subscribed && (
                //     <button
                //       className={`tab-button ${selectedTab === "bot-trading" ? "order-tab-active" : ""
                //         }`}
                //       onClick={() => {
                //         handleTabClick("bot-trading");
                //         // mkRipple(e);
                //       }}
                //       style={{
                //         position: 'relative',
                //         overflow: 'hidden',
                //         isolation: 'isolate',
                //       }}
                //     >
                //       <Ripple />
                //       <span style={{
                //         display: 'flex',
                //         alignItems: 'center',
                //         justifyContent: 'center',
                //         gap: '0.5rem',
                //       }}>
                //         <span>
                //           iBot
                //         </span>
                //         <RiRobot2Line height={14} />
                //       </span>
                //     </button>
                //   )}
                // </div>
                <div ref={orderTabsRef} className="order-tabs-binance" style={{ '--tab-count': subscribed ? 3 : 2, '--tab-index': selectedTab === 'market' ? 0 : selectedTab === 'pending-order' ? 1 : 2 } as React.CSSProperties}>
                  <TabIndicator activeKey={selectedTab} />
                  <button type="button"

                    className={`tab-button-binance ${selectedTab === "market" ? "order-tab-active" : ""}`}
                    onClick={() => handleTabClick("market")}
                  >
                    {t('orderPanel.marketOrder')}
                  </button>

                  <button type="button"

                    className={`tab-button-binance ${selectedTab === "pending-order" ? "order-tab-active" : ""}`}
                    onClick={() => handleTabClick("pending-order")}
                  >
                    {t('orderPanel.pendingOrder')}
                  </button>

                  {subscribed && (
                    <button
                      className={`tab-button-binance ${selectedTab === "bot-trading" ? "order-tab-active" : ""}`}
                      onClick={() => handleTabClick("bot-trading")}
                    >
                      <span className="tab-content">
                        <span>iBot</span>
                        <RiRobot2Line size={14} />
                      </span>
                    </button>
                  )}
                </div>

                ||
                <div className="market-dropdown">
                  <SystemSelect
                    options={marketTypeOptions.filter((option) => {
                      if (option.value == "bot-trading") {
                        return subscribed
                      }
                      return true
                    })}
                    value={marketTypeOptions.find((option) => option.value === selectedTab)}
                    onChange={(selectedOption) => handleTabClick(selectedOption?.value)}
                    // styles={customStyle}
                    isSearchable={false}
                    menuPortalTarget={document.body}
                    styles={customStyles}
                  />
                </div>
              }

              {/* <div className="order-tabs">
                <button
                  className={`tab-button ${selectedTab === "market" ? "order-tab-active" : ""
                    }`}
                  onClick={() => {
                    handleTabClick("market");
                  }}
                  style={{
                    position: 'relative',
                    overflow: 'hidden',
                    isolation: 'isolate',
                  }}
                >
                  <Ripple />
                  Market
                </button>
                <button
                  className={`tab-button ${selectedTab === "pending-order" ? "order-tab-active" : ""
                    }`}
                  onClick={() => {
                    handleTabClick("pending-order");
                  }}
                  style={{
                    position: 'relative',
                    overflow: 'hidden',
                    isolation: 'isolate',
                  }}
                >
                  <Ripple />
                  Pending Order
                </button>
                {subscribed && (
                <button
                  className={`tab-button ${selectedTab === "bot-trading" ? "order-tab-active" : ""
                    }`}
                  onClick={() => {
                    handleTabClick("bot-trading");
                    // mkRipple(e);
                  }}
                  style={{
                    position: 'relative',
                    overflow: 'hidden',
                    isolation: 'isolate',
                  }}
                >
                  <Ripple />
                  <span style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '0.5rem',
                  }}>
                    <span>
                      iBot
                    </span>
                    <RiRobot2Line height={14} />
                  </span>
                </button>
                )}
              </div> */}

              {/* <div className="market-dropdown">
                <Select
                  options={marketTypeOptions.filter((option) => {
                    if (option.value == "bot-trading") {
                      return subscribed
                    }
                    return true
                  })}
                  value={marketTypeOptions.find((option) => option.value === selectedTab)}
                  onChange={(selectedOption) => handleTabClick(selectedOption?.value)}
                  // styles={customStyle}
                  isSearchable={false}
                  menuPortalTarget={document.body}
                  styles={customStyles}
                />
              </div> */}
              <div
                className={`order-section ${selectedTab === "market" ? "visible" : "hidden"
                  }`}
                id="market"
              >

                <MarketOrder selectedOrderTab={selectedTab} />
              </div>
              <div
                className={`order-section ${selectedTab === "pending-order" ? "visible" : "hidden"
                  }`}
                id="pending"
              >
                <PendingOrder selectedOrderTab={selectedTab} />
              </div>
              {subscribed && (
                <div
                  className={`order-section ${selectedTab === "bot-trading" ? "visible" : "hidden"
                    }`}
                  id="bot"
                >
                  <BotPanel selectedOrderTab={selectedTab} />
                </div>
              )}
            </div>
          </div>

          {/* Symbols Info */}
          <div
            className="collapse-card-header"
            role="button"
            tabIndex={0}
            aria-expanded={Boolean(collapseState["symbols"])}
            onKeyDown={(event) => {
              if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault();
                event.currentTarget.click();
              }
            }}
            onClick={(event) => handleCollapseClick("symbols", event)}
          >
            <label htmlFor="text">{t('orderPanel.symbolInfoTitle')}</label>
            <div className="arrow-icons" data-expanded={collapseState["symbols"]} aria-hidden="true"><BsArrowDownSquare /></div>
          </div>
          <div
            className={`collapse-card-container`}
            role={`${collapseState["symbols"] ? "visible" : "hidden"}`}
          >
            <div className="collapse-card-wrapper">
              <div className="symbol-info-panel">
                <ul className="symbol-info-list">
                  {symbolListData[selectedAuthSymbol]?.description && (
                    <li style={{ alignItems: 'flex-start', gap: '15px' }}>
                      <strong style={{ flexShrink: 0, marginTop: '2px' }}>{t('orderPanel.description')}</strong>{" "}
                      <span style={{ textAlign: 'right', wordBreak: 'break-word', lineHeight: '1.4' }}>{translateSymbolDescription(symbolListData[selectedAuthSymbol].description, t)}</span>
                    </li>
                  )}
                  <li>
                    <strong>{t('orderPanel.pipPosition')}</strong>{" "}
                    <span>{symbolInfo?.pip_position}</span>
                  </li>
                  <li>
                    <strong>{t('orderPanel.baseAsset')}</strong> <span>{symbolInfo?.base_asset}</span>
                  </li>
                  <li>
                    <strong>{t('orderPanel.quoteAsset')}</strong> <span>{symbolInfo?.quote_asset}</span>
                  </li>
                  {/* <li>
                    <strong>Swap (long)</strong>{" "}
                    <span>{formatSwapRate(symbolInfo?.swap_long)}</span>
                  </li>
                  <li>
                    <strong>Swap (short)</strong>{" "}
                    <span>{formatSwapRate(symbolInfo?.swap_short)}</span>
                  </li>
                  <li>
                    <strong>3-day swaps</strong>{" "}
                    <span>{parseInt(symbolInfo?.three_day_swaps) || '\u2014'}</span>
                  </li> */}
                  {symbolInfo?.hide_swap_details ? (
                    <>
                      <li>
                        <strong>{t('orderPanel.swapLong')}</strong>{" "}
                        <span>{formatSwapRate(symbolInfo?.swap_long)}</span>
                      </li>
                      <li>
                        <strong>{t('orderPanel.swapShort')}</strong>{" "}
                        <span>{formatSwapRate(symbolInfo?.swap_short)}</span>
                      </li>
                      <li>
                        <strong>{t('orderPanel.threeDaySwaps')}</strong>{" "}
                        <span>{translateThreeDaySwap(symbolInfo?.three_day_swaps, t) || '\u2014'}</span>
                      </li>
                      <li>
                        <strong>{t('orderPanel.weekendSwaps')}</strong>{" "}
                        <span>{symbolInfo?.weekend_swap || '\u2014'}</span>
                      </li>
                      <li>
                        <strong>{t('orderPanel.swapTimeServer')}</strong>{" "}
                        <span>{symbolInfo?.swap_time || '\u2014'}</span>
                      </li>
                      <li>
                        <strong>{t('orderPanel.swapPeriodLabel')}</strong>{" "}
                        <span>{symbolInfo?.swap_period || '\u2014'}</span>
                      </li>
                      <li>
                        <strong>{t('orderPanel.gracePeriod')}</strong>{" "}
                        <span>{symbolInfo?.grace_period || '\u2014'}</span>
                      </li>
                    </>
                  ) : (<></>)}

                </ul>
              </div>
            </div>
          </div>

          {/* Markets sections */}
          {
            false && (<div
              className="collapse-card-header"
              role="button"
            tabIndex={0}
            aria-expanded={Boolean(collapseState["market_hours"])}
            onKeyDown={(event) => {
              if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault();
                event.currentTarget.click();
              }
            }}
            onClick={(event) => handleCollapseClick("market_hours", event)}
            >
              <label htmlFor="text">{t('orderPanel.marketHours')}</label>
              <div className="arrow-icons" data-expanded={collapseState["market_hours"]} aria-hidden="true"><BsArrowDownSquare /></div>
            </div>)
          }
          <div
            className={`collapse-card-container`}
            role={`${collapseState["market_hours"] ? "visible" : "hidden"}`}
          >
            <div className="collapse-card-wrapper">
              <div className="market-hours-panel">
                <ul className="market-hours-list">
                  {Array.isArray(marketHours) &&
                    marketHours.map((market_hours, index) => {
                      return (
                        <li key={index}>
                          <strong>
                            {market_hours.start_day} {market_hours.start_time} -{" "}
                            {market_hours.end_time}
                          </strong>{" "}
                          <span>
                            <GoDotFill className={market_hours.is_active == true ? 'svg-green' : 'svg-red'} />
                          </span>
                        </li>
                      );
                    })}
                </ul>
              </div>
            </div>
          </div>

          {/* leverage sections */}
          <div>
            {(() => {
              return null;
            })()}
            {leverage && leverage.length > 0 && hideLeverageCard && (
              <div>
                <div
                  className="collapse-card-header"
                  role="button"
            tabIndex={0}
            aria-expanded={Boolean(collapseState["leverage"])}
            onKeyDown={(event) => {
              if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault();
                event.currentTarget.click();
              }
            }}
            onClick={(event) => handleCollapseClick("leverage", event)}
                >
                  <label htmlFor="text">{t('orderPanel.leverageTitle')}</label>
                  <div className="arrow-icons" data-expanded={collapseState["leverage"]} aria-hidden="true"><BsArrowDownSquare /></div>
                </div>
                <div
                  className={`collapse-card-container`}
                  role={`${collapseState["leverage"] ? "visible" : "hidden"}`}
                >
                  <div className="collapse-card-wrapper">
                    <div className="leverage-panel">
                      <ul className="leverage-list">
                        <li className="leverage-heading">
                          <strong>{t('orderPanel.volume')}</strong>
                          <strong>{t('orderPanel.leverage')}</strong>
                          <strong>{t('orderPanel.status')}</strong>
                        </li>
                        {leverage && Array.isArray(leverage[0]?.group_level_leverage) && leverage[0]?.group_level_leverage.length > 0 ? (
                          (() => {
                            const selectedOption = getExposureLevel(currentExposureLevel, leverage[0]?.group_level_leverage);
                            let isSelected = false;
                            return leverage[0]?.group_level_leverage.map((lvg, index) => {
                              const isLast = index === leverage[0].group_level_leverage.length - 1;
                              const getMinLvgVar = getMinimumLeverage(leverage[0].user_default_leverage, lvg.max_leverage, []);
                              isSelected = lvg?.exposure_level === selectedOption?.exposure_level;

                              const svgClass = isSelected ? 'svg-green' : 'svg-red';

                              return (
                                <li key={index}>
                                  <span style={{ display: 'flex', alignItems: 'center' }}>
                                    <span className="marginRight" style={{ textAlign: 'center', fontSize: '1.5em' }}>{isLast ? '∞' : '≤'}</span>
                                    <span style={{ textAlign: 'center', fontSize: '1.0em' }}>{lvg?.exposure_level}</span>
                                  </span>
                                  <span>1:{getMinLvgVar}</span>{" "}
                                  <span>
                                    <GoDotFill className={
                                      svgClass
                                    } />
                                  </span>
                                </li>
                              );
                            });
                          })()
                        )
                          : leverage && Array.isArray(leverage[0]?.symbol_default_leverage) && leverage[0]?.symbol_default_leverage.length > 0 ? (
                            (() => {
                              // Check if activeLvg matches all getMinLvgVar in symbol_default_leverage
                              let isSelected = false;
                              const selectedOption = getExposureLevel(currentExposureLevel, leverage[0]?.symbol_default_leverage);
                              return leverage[0]?.symbol_default_leverage?.map((lvg, index) => {
                                const isLast = index === leverage[0].symbol_default_leverage.length - 1;
                                const getMinLvgVar = getMinimumLeverage(leverage[0]?.user_default_leverage, [], lvg?.max_leverage);
                                isSelected = lvg?.exposure_level === selectedOption?.exposure_level;

                                const svgClass = isSelected ? 'svg-green' : 'svg-red';
                                return (
                                  <li key={index}>
                                    <span style={{ display: 'flex', alignItems: 'center' }}>
                                      <span className="marginRight" style={{ textAlign: 'center', fontSize: '1.5em' }}>{isLast ? '∞' : '≤'}</span>
                                      <span style={{ textAlign: 'center', fontSize: '1.0em' }}>{lvg?.exposure_level}</span>
                                    </span>
                                    <span>1:{getMinLvgVar}</span>{" "}
                                    <span>
                                      <GoDotFill className={
                                        svgClass
                                      } />
                                    </span>
                                  </li>
                                );
                              });
                            })()
                          ) : <li >
                            <span> </span>{" "}
                            <span>1:{leverage[0].user_default_leverage} </span>
                            <span><GoDotFill className={activeLvg == parseInt(leverage[0]?.user_default_leverage) ? 'svg-green' : 'svg-red'} /></span>
                          </li>
                        }
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>

          {isHidden &&
            <div
              className="collapse-card-header"
              role="button"
            tabIndex={0}
            aria-expanded={Boolean(collapseState["promotion"])}
            onKeyDown={(event) => {
              if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault();
                event.currentTarget.click();
              }
            }}
            onClick={(event) => handleCollapseClick("promotion", event)}
            >
              <label htmlFor="text">{t('orderPanel.promotion')}</label>
              <div className="arrow-icons" data-expanded={collapseState["promotion"]} aria-hidden="true"><BsArrowDownSquare /></div>
            </div>
          }
          {/* prmotion section  */}
          {isHidden &&
            <div
              className={`collapse-card-container ${collapseState["promotion"] ? "visible" : "hidden"
                }`}
              role={`${collapseState["promotion"] ? "visible" : "hidden"}`}
            >
              <div className="collapse-card-wrapper">
                <UpdateSection />
              </div>
            </div>
          }

        </div>
        <div className={`settings-right-panel ${settingsClass}`}>
          <div className="main-row">
            {canShowChallengeSwitcher && (
              <div className="challenge-accounts-select symbol-selector-container">
                <label className="challenge-accounts-select__label" htmlFor="challenge-account-switcher">
                  {t('settings.switchAccount')}
                </label>
                <div className="challenge-account-picker">
                <SystemSelect
                  inputId="challenge-account-switcher"
                  styles={challengeAccountSelectStyles}
                  value={selectedChildAccount}
                  onChange={handleChangeChildAccount}
                  onMenuOpen={handleChildAccountMenuOpen}
                  options={childAccountOptions}
                  components={challengeAccountSelectComponents}
                  isDisabled={isChildLoginLoading}
                  isLoading={isChildLoginLoading || isChildUsersLoading}
                  placeholder={t('settings.selectAccount')}
                  menuPlacement="auto"
                />
                </div>
              </div>
            )}
            <div className="settings-row header-select-container">
              <h2>{t('settings.appearance')}</h2>
              <SystemSelect className="settings-select" aria-label={t('settings.appearance')}
                value={appearanceOptions.find(option => option.value === theme)}
                options={appearanceOptions}
                onChange={option => option && setTheme(option.value)} />
            </div>
            <div className="settings-row  header-select-container">
              <h2><FiGlobe aria-hidden="true" />{t('common.language')}</h2>
              <SystemSelect className="settings-select" classNamePrefix="settings-select" aria-label={t('common.language')}
                styles={orderCustomStyles}
                value={localeOptions.find((o) => o.value === activeLocale) ?? localeOptions[0]}
                onChange={handleChangeLocale}
                options={localeOptions}
                menuPlacement="auto"
              />
            </div>
            <div className="settings-row  header-select-container" >
              <h2><FiClock aria-hidden="true" />{t('settings.currentTimeZone')}</h2>
              <SystemSelect className="settings-select" classNamePrefix="settings-select" aria-label={t('settings.currentTimeZone')}
                styles={orderCustomStyles}
                value={options.find(option => option.value === utcOffset)}
                onChange={handleChangeUTCOffset}
                options={options}
                menuPlacement="auto"
              />
            </div>
            <div className="settings-row ">
              <UTCTimeConverter />
            </div>
            <div className="tooltip-toggle settings-row " style={{ borderBottom: "1px solid var(--surface-bg, #1a1f36)" }}>
              <h2>{t('settings.showTooltip')}</h2>
              <div className="row-2-col-2" style={{ marginTop: "10px" }}>
                <Switch
                  aria-label={t('settings.showTooltip')}
                  subscribed={handleTooltipToggle}
                  handleToggle={handleTooltipToggle}
                  isChecked={showTooltip}
                // uncheckedIcon={false}
                // checkedIcon={false}
                // offColor="#888"
                // onColor="#4caf50"
                />
              </div>
            </div>
            <div
              className="tooltip-toggle settings-row "
              style={{ borderBottom: "1px solid var(--surface-bg, #1a1f36)" }}
            >
              <h2>{t('settings.floatingWindow')}</h2>
              <div className="row-2-col-2" style={{ marginTop: "10px" }}>
                <Switch
                  aria-label={t('settings.floatingWindow')}
                  handleToggle={() => setShowFloatingWindow(prev => !prev)}
                  isChecked={showFloatingWindow}
                  subscribed={setShowFloatingWindow}
                />
              </div>
            </div>
            <div className="style-settings-container settings-row ">
              <h2>{t('settings.styleSettings')}</h2>
              <SystemSelect className="settings-select" classNamePrefix="settings-select" aria-label={t('settings.styleSettings')}
                styles={orderCustomStyles}
                value={selectedStyle} options={styleOptions}
                getOptionValue={option => option.name}
                getOptionLabel={option => translateChartStyleName(option, t)}
                onChange={option => { if (option) setSelectedStyle(option); }}
                isSearchable={false} menuPlacement="auto"
                formatOptionLabel={option => <span className="settings-style-choice"><span className="settings-swatches">{option.colors.map((color, index) => <i key={index} style={{ backgroundColor: color }} />)}</span>{translateChartStyleName(option, t)}</span>}
              />
            </div>
            {/* <div className="tooltip-toggle font-adjuster -setting-panel-divider" style={{borderBottom:"1px solid #232323"}}>
              <h2>{t('settings.showBullets')}</h2>
              <div className="row-2-col-2" style={{ marginTop: "10px" }}>
                <Switch
                  subscribed={setShowBullets}
                  handleToggle={setShowBullets}
                  isChecked={showBullets}
                  // uncheckedIcon={false}
                  // checkedIcon={false}
                  // offColor="#888"
                  // onColor="#4caf50"
                  />
              </div>
            </div> */}
          </div>
        </div>

        {isHidden &&
          <div className={`settings-right-panel ${updatePanelClass}`}>
            <div className="main-row">
              {/* <h1>Adds</h1> */}
            </div>
            {/* <UpdateSection /> */}
          </div>
        }

        <div className={`notification-right-panel ${notificationClass}`}>
          <div className="main-row">
            {/* < SystemNotification /> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default OrderPanel;
